import React, {useEffect, useRef} from 'react';
import {useForm} from 'react-hook-form';
import {FlatList, ScrollView, StyleSheet, Text, View} from 'react-native';
import {SafeAreaView, useSafeAreaInsets} from 'react-native-safe-area-context';
import {useDispatch, useSelector} from 'react-redux';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import Width from '../../../assets/Width';
import FastImage from '../../../common/FastImage';
import {globalImport} from '../../../common/globalImports';
import CustomInput from '../../../commonComponents/CustomInput';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import Header from '../../../commonComponents/Header';
import {conversion, smile_coin, usdtIcon} from '../../../utils/images';
import {Network} from '../../../utils/network';
import {getUser} from '../../Profile/redux/profile.action';
import WalletAddressTextBox from '../childComponents/walletAddressTextBox';
import {Button} from '../../../components/core/Button';

const RedeemRewards = ({navigation, route}) => {
  const conversionMediumData = route?.params?.limitData;
  const isWithdrawUSTDT = conversionMediumData?.isUSDT;
  const ref = useRef(null);
  const [respError, setResponseError] = React.useState();
  const {
    control,
    formState: {errors, isValid, isSubmitting},
    handleSubmit,
    setValue,
    watch,
  } = useForm({mode: 'onChange'});
  let userInfo = useSelector(({profile}) => profile.profileData);
  const amount = watch('amount');
  const wallet_address = userInfo?.wallet_address;
  const walletAddress = watch('walletAddress');
  const dispatch = useDispatch();

  useEffect(() => {
    if (wallet_address) {
      setValue('walletAddress', wallet_address);
    }
  }, [wallet_address]);
  const onPlaceOrderClick = async () => {
    if (!isWithdrawUSTDT) {
      const res = await Network.redeemSmileCoins(
        {
          amount: parseFloat(amount),
        },
        true,
      );
      apiResponseHandling(
        res,
        !res?.data?.status || res?.data?.error ? null : 'Redeem Successful!',
      );
    } else {
      putRedeemRequest();
    }
  };

  const putRedeemRequest = async () => {
    const res = await Network.redeemCryptoSmileCoins(
      {
        amount: parseFloat(amount),
        walletAddress: walletAddress,
      },
      true,
    );

    if (!res?.data?.success || res?.data?.error) {
      setResponseError({
        val: res?.data?.message,
        class: {color: Colors.red},
        divClass: {borderColor: Colors.red, borderWidth: 2},
      });
    } else {
      setResponseError({
        val: res?.data?.message,
        class: {color: Colors.green},
        divClass: {borderColor: Colors.green, borderWidth: 2},
      });

      navigation.push('WalletStack', {
        screen: 'WalletAmountReview',
        params: {
          amount: amount,
          confirmDepositClick: confirmCryproPayout,
          rechargeDetails: res?.data?.results,
          isCryptoPayout: true,
        },
      });

      // navigation.navigate('WalletAmountReview', {
      //   amount: amount,
      //   confirmDepositClick: confirmCryproPayout,
      //   rechargeDetails: res?.data,
      //   isCryptoPayout: true,
      // });
    }
  };

  const apiResponseHandling = (res, title) => {
    if (!res?.data?.status || res?.data?.error) {
      const status = {
        isShow: true,
        status: false,
        msg: res?.data?.message,
        amount: amount,
        disclaimer: res?.data?.disclaimer,
      };

      navigation.push('WalletStack', {
        screen: 'WalletStatus',
        params: {paymentStatus: status},
      });
    } else {
      dispatch(getUser());
      const status = {
        isShow: true,
        status: true,
        title: title,
        amount: amount,
        msg: res?.data?.msg,
        disclaimer: res?.data?.disclaimer,
      };

      navigation.push('WalletStack', {
        screen: 'WalletStatus',
        params: {paymentStatus: status},
      });
    }
  };

  const confirmCryproPayout = async data => {
    let res = await Network.redeemCryptoConfirmSmileCoins(
      {
        payout_reference: data?.payout_reference,
      },
      true,
    );
    if (res?.data?.success) {
      res.data.status = true;
    }
    apiResponseHandling(
      res,
      !res?.data?.status || res?.data?.error ? null : 'Withdrawal Processing',
    );
  };
  const maxLimit = conversionMediumData?.limit?.maximum;
  const minSmileCoinBalance = conversionMediumData?.limit?.minimumBalance;
  const smileCoinBalance = userInfo?.coinsp?.toFixed(2);

  const rightCoinElement = title => {
    return (
      <View
        style={[
          styles.smcCoin,
          title
            ? globalImport.isWeb
              ? {
                  position: 'initial',
                }
              : {position: 'absolute', right: 0, top: 8}
            : null,
        ]}>
        <FastImage
          style={{
            width: 24,
            height: 24,
          }}
          source={title ? usdtIcon() : smile_coin()}
        />
        <FormTextLabel
          label={title ?? 'LT'}
          labelStyles={[globalFontStyle.appFontSmallText, {marginLeft: 5}]}
        />
      </View>
    );
  };
  return (
    <SafeAreaView style={[globalStyle.pageContainer, {flexGrow: 1}]} ref={ref}>
      <ScrollView
        contentContainerStyle={{flexGrow: 1}}
        keyboardShouldPersistTaps="handled"
        nestedScrollEnabled={true}>
        <Header
          isInternalPage={false}
          navigation={navigation}
          pageName={''}
          backGroundColor={'#FFFFFF'}
          translate={true}
        />
        <View
          style={{
            paddingHorizontal: 18,
            marginTop: 30,
            justifyContent: 'space-between',
            flex: 1,
          }}>
          <View>
            <View>
              <FormTextLabel
                label={'Redeem Tokens'}
                labelStyles={[globalFontStyle.appFontHeading]}
              />
              <FormTextLabel
                label={
                  isWithdrawUSTDT
                    ? 'Transfer tokens to your USDT wallet address'
                    : ''
                }
                labelStyles={[globalFontStyle.appFontBody, {marginTop: 5}]}
              />
              <Text
                style={[
                  globalFontStyle.appFontSmallText,
                  {color: Colors.black2, marginTop: 5},
                ]}>
                {conversionMediumData?.exchange_string}
              </Text>
            </View>
            <View style={{marginTop: 25}}>
              <CustomInput
                name="amount"
                placeholder={''}
                control={control}
                isTextAlignLeft={true}
                translate={true}
                customStyle={styles.inputblock}
                rules={{
                  required: 'Please enter a valid amount',
                  min: 1,
                  max: maxLimit,
                  validate: {
                    checkCoin: value => {
                      return (
                        smileCoinBalance >= minSmileCoinBalance ||
                        `Min ${minSmileCoinBalance} tokens required in order to be eligible for redeem`
                      );
                    },
                  },
                }}
                //isLoginStyle={true}
              />
              <View style={{top: 46, left: 9, position: 'absolute'}}>
                <FormTextLabel
                  label={'Balance: '}
                  labelStyles={[
                    globalFontStyle.appFontSmallText,
                    {color: Color.black2},
                  ]}>
                  <Text style={{color: Color.blue1}}>{smileCoinBalance}</Text>
                </FormTextLabel>
              </View>
              <>{rightCoinElement()}</>
              <View
                style={{
                  top: 74 - 20 + 10,
                  left: globalImport.isWeb
                    ? (window.innerWidth - 32 - 40) / 2
                    : (Width.width - 32 - 40) / 2,
                  position: 'absolute',
                  zIndex: 20,
                }}>
                <FastImage
                  style={{
                    width: 40,
                    height: 40,
                  }}
                  source={conversion()}
                />
              </View>

              <View
                style={[
                  styles.conversionBlock,
                  isWithdrawUSTDT ? {paddingRight: 6} : null,
                ]}>
                <FormTextLabel
                  label={
                    amount
                      ? parseFloat(
                          amount * conversionMediumData?.exchangeRate,
                        )?.toFixed(2)
                      : 'N/A'
                  }
                  labelStyles={[
                    globalFontStyle.appFontTitle,
                    amount ? null : {color: Color.grey9},
                  ]}
                />

                {isWithdrawUSTDT ? (
                  <>{rightCoinElement('USDT')}</>
                ) : (
                  <FormTextLabel
                    label={'Credits'}
                    labelStyles={[
                      globalFontStyle.appFontSubText,
                      {color: Colors.grey2},
                    ]}
                  />
                )}
              </View>
              {errors?.amount?.type === 'required' && (
                <FormTextLabel
                  labelStyles={globalStyle.errorText}
                  label={'Please enter a valid amount'}
                />
              )}
              {errors?.amount?.type === 'max' && (
                <FormTextLabel
                  labelStyles={globalStyle.errorText}
                  label={`Max ${maxLimit} tokens per day allowed`}
                />
              )}
              {errors?.amount?.type === 'checkCoin' && (
                <FormTextLabel
                  labelStyles={globalStyle.errorText}
                  label={`Min ${minSmileCoinBalance} tokens required in order to be eligible for redeem`}
                />
              )}
            </View>
          </View>
          {isWithdrawUSTDT && (
            <WalletAddressTextBox
              respError={respError}
              control={control}
              errors={errors}
            />
          )}
          <View style={{flex: 1}} />
          {conversionMediumData?.guidline?.items?.length > 0 && (
            <View
              style={{
                //flex: 0,
                marginTop: 10,
                padding: 13,
                paddingBottom: 110,
                backgroundColor: '#F4F4F4',
              }}>
              <FormTextLabel
                label={'Redeem Guidelines'}
                labelStyles={[
                  globalFontStyle.appFontSubTextBold,
                  {marginBottom: 5},
                ]}
              />
              <FlatList
                scrollEnabled
                data={conversionMediumData?.guidline?.items}
                renderItem={({item, index}) => {
                  return (
                    <Text key={index}>
                      <Text
                        style={{
                          ...globalFontStyle.appFontSmallText,
                          color: Colors.grey2,
                        }}>
                        {`\u2022 ${item}`}
                      </Text>
                    </Text>
                  );
                }}
                keyExtractor={(item, index) => index}
                showsVerticalScrollIndicator={false}
                initialNumToRender={10}
              />
            </View>
          )}
        </View>

        <View style={[globalStyle.customBtnParentModalStyle]}>
          <Button
            variant="primary"
            onPress={handleSubmit(onPlaceOrderClick)}
            disabled={!isValid}
            translate={true}
          >
            Redeem
          </Button>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default RedeemRewards;

const styles = StyleSheet.create({
  smcCoin: {
    borderRadius: 100,
    backgroundColor: Colors.grey8,
    padding: 0,
    alignItems: 'center',
    margin: 0,
    position: 'absolute',
    right: 5,
    paddingVertical: 7,
    paddingLeft: 10,
    paddingRight: 16,
    zIndex: 100,
    flexDirection: 'row',
    top: (74 - 30) / 2,
  },
  inputblock: {
    borderColor: Colors.black3,
    borderWidth: 1.5,
    height: 74,
    paddingTop: 10,
    paddingRight: 100,
    borderRadius: 5,
    ...globalFontStyle.appFontTitle,
    paddingBottom: 20,
  },
  conversionBlock: {
    borderColor: Colors.black3,
    borderWidth: 1.5,
    marginTop: 12,
    height: 55,
    paddingHorizontal: 16,
    borderRadius: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...globalFontStyle.appFontHeadingRegular,
    paddingVertical: 8,
  },
});
